import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import beCashupBreakdown from 'actions/cashup/beCashupBreakdown.action';
import beSaveCashupReconcile from 'actions/cashup/beSaveCashupReconcile.action';
import feCleanCashupData from 'actions/cashup/feCleanCashupData.action';
import feSetSelectedStaff from 'actions/cashup/feSetSelectedStaff.action';
import feUpdateCashupData from 'actions/cashup/feUpdateCashupData.action';
import fetchSalon from 'actions/fetchSalon.action';
import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import setupCheckout from 'bl/checkout/setupCheckout.bl';
import CashupAll from 'components/cashup/CashupAll.component';
import CashupOwn from 'components/cashup/CashupOwn.component';
import Permitted from 'components/core/Permitted.component';
import PERM from 'constants/core/perm.const';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useThemeWithBright } from 'providers/Theme.provider';
import { selectCashup, selectCashupResultStylistId, selectCashupSelectedStaff, selectCashupSelectedStaffGroup, selectCashupSelectedStylistIds } from 'selectors/cashup.selectors';
import { selectCurrentSalon, selectCurrentSalonClientsArray, selectCurrentSalonId, selectCurrentSalonStylists } from 'selectors/currentSalon.selectors';
import { selectRsBeSaveCashupReconcile } from 'selectors/request.selectors';
import logger from 'utils/logger.util';

import { fetchDepositData, hideError, resetSaved, voidAndGetDetails } from 'cashup/actions';
import CashupForbidden from 'cashup/CashupForbidden.component';
import CashupStylesImporter from 'cashup/CashupStylesImporter.component';
import { clearTransactionLog, setCheckoutInitDataFromCashup } from 'checkout/actions';
import { fetchProductList, getCategories, getClientsList } from 'salon/actions';

const L = logger('CashupPage');

const CashupLoader = ({ children, fetchProductList, fetchSalon, fetchStylistsBySalon, getCategories, getClientsList }) => {
  const salonId = useCurrentSalonId();

  useEffect(() => {
    // these are common for both versions of the cashup (all and own)

    L.unignore('()', 'getCategories:', getCategories(salonId));
    L.unignore('()', 'getClientsList:', getClientsList(salonId));
    L.unignore('()', 'fetchProductList:', fetchProductList(salonId));
    L.unignore('()', 'fetchSalon:', fetchSalon(salonId));
    L.unignore('()', 'fetchStylistsBySalon:', fetchStylistsBySalon(salonId));

    //
  }, [fetchProductList, fetchSalon, fetchStylistsBySalon, getCategories, getClientsList, salonId]);

  return <>{children}</>;
};

const CashupPage = (props) => {
  const theme = useThemeWithBright();
  const salonId = useCurrentSalonId();

  L.debug('()', salonId, props, theme);

  return (
    <CashupStylesImporter>
      <Permitted value={PERM.canViewDailyCashupPersonal}>
        <CashupLoader {...props}>
          <CashupOwn {...props} {...theme} salonId={salonId} />
        </CashupLoader>
      </Permitted>

      <Permitted value={PERM.canViewDailyCashupAllStaff}>
        <CashupLoader {...props}>
          <CashupAll {...props} {...theme} salonId={salonId} />
        </CashupLoader>
      </Permitted>

      <Permitted not value={PERM.canViewDailyCashupPersonal}>
        <Permitted not value={PERM.canViewDailyCashupAllStaff}>
          <CashupForbidden />
        </Permitted>
      </Permitted>
    </CashupStylesImporter>
  );
};

const mapStateToProps = (state) => ({
  cashup: selectCashup(state),
  clients: selectCurrentSalonClientsArray(state),
  resultStylistId: selectCashupResultStylistId(state),
  rsBeSaveCashupReconcile: selectRsBeSaveCashupReconcile(state),
  salonDetails: selectCurrentSalon(state),
  salonId: selectCurrentSalonId(state),
  selectedStaff: selectCashupSelectedStaff(state),
  selectedStaffGroup: selectCashupSelectedStaffGroup(state),
  selectedStylistIds: selectCashupSelectedStylistIds(state),
  stylistList: selectCurrentSalonStylists(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchStylistsBySalon,
      getCategories,
      getClientsList,
      fetchProductList,
      fetchSalon,

      beCashupBreakdown,
      beSaveCashupReconcile,
      clearTransactionLog,
      feCleanCashupData,
      feSetSelectedStaff,
      feUpdateCashupData,
      fetchDepositData,
      hideError,
      resetSaved,
      setCheckoutInitData: setupCheckout,
      setCheckoutInitDataFromCashup,
      voidAndGetDetails,
    },
    dispatch,
  );

const CashupPageHoc = connect(mapStateToProps, mapDispatchToProps)(CashupPage);

export default CashupPageHoc;
